<template>
  <label v-if="label" :for="uuid">
    {{ label }} <span v-if="required" class="star" style="vertical-align: middle;">*</span>
  </label>

  <input class="field" v-bind="{
    ...$attrs,
    onInput: updateValue,
  }" :id="uuid" :value="modelValue" :placeholder="label" :aria-describedby="error ? `${uuid}-error` : null"
    :aria-invalid="error ? true : false" :class="{ error }" role="textbox" />

  <BaseErrorMessage v-if="error" :id="`${uuid}-error`">
    {{ error }}
  </BaseErrorMessage>
</template>

<script>
import SetupFormComponent from '@/features/SetupFormComponent'
import UniqueID from '@/features/UniqueID'

export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
  },
  setup(props, context) {
    const { updateValue } = SetupFormComponent(props, context)
    const uuid = UniqueID().getID()

    return {
      updateValue,
      uuid,
    }
  },
}
</script>

<style scoped>
label {
  color: black;
}

.star {
  color: #9E0000;
  font-weight: bolder;
  /* Make it red */
  font-size: 1.5em;
}

.field {
  border-radius: 10px;
  border-color: #0c0c72;
}
</style>
